<div>
  <form>
    <label>Opt out of an endpoint type</label>
    <div class="row padded form-group">
      <div class="col-md-12" *ngIf="optOut !== null">
        <div *ngFor="let opt of optOut; let i = index" class="border-card-padding form-group col-lg-12">
          <button
            class="btn btn-attention float-right"
            type="button"
            (click)="removeConsequence(opt)"
            title="Remove Consequence"
          >
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
          <form>
            <div class="form-group">
              <label>Endpoint Type</label>
              <select
                name="consequence_{{ opt.endpointType }}"
                class="form-control"
                [(ngModel)]="opt.endpointType"
                (ngModelChange)="updateConsequences()"
              >
                <option
                  *ngFor="let type of endpointTypes"
                  [selected]="type.name === opt.endpointType"
                  [value]="type.name"
                >
                  {{ type.name }}
                </option>
              </select>
            </div>
          </form>
        </div>
      </div>
      <div class="form-group col-md-12">
        <button class="btn btn-default float-right" (click)="initConsequenceObject()">
          <fa-icon [icon]="faPlus"></fa-icon> Add Opt Out Consequence
        </button>
      </div>
    </div>
  </form>
</div>
